import { defineMessages } from 'react-intl';

export const texts = defineMessages({
  error: {
    id: 'AmountBadge.error',
    description: 'Error message',
    defaultMessage: 'Kunde inte hämta',
  },
});
